import { render, staticRenderFns } from "./add-operate.vue?vue&type=template&id=e567ca72&scoped=true&"
import script from "./add-operate.vue?vue&type=script&lang=js&"
export * from "./add-operate.vue?vue&type=script&lang=js&"
import style0 from "./add-operate.vue?vue&type=style&index=0&id=e567ca72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e567ca72",
  null
  
)

export default component.exports